if(!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      if(this.form) this.form.addEventListener('change', this.submit.bind(this));
    }

    disconnectedCallback() {
      if(this.form) this.form.removeEventListener('change', this.submit.bind(this));
    }

    submit() {
      if(this.form) this.form.submit();
    }

    get form() {
      return this.querySelector('form');
    }
  }
  customElements.define('localization-form', LocalizationForm);
}